module.exports = __webpack_public_path__ + "public/img/caiji.24181f10.png";